import Axios from "axios";

const host = "https://api.intercom.io";

const headers = () => ({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${process.env.INTERCOM_TOKEN}`,
  },
});

export const getCompany = async (companyId: string) => {
  try {
    const result = await Axios.get(
      `${host}/companies?company_id=${companyId}`,
      {
        ...headers(),
      },
    );
    return result.data;
  } catch (error) {
    return;
    // console.log(error.headers, error.response);
    // throw error;
    // if (AxiosError.isAxiosError(error)) {
    //   console.log(error.response?.data);
    // }
  }
};

export const createCompany = async (params: any) => {
  const post = await Axios.post(`${host}/companies`, params, {
    ...headers(),
  });

  return post.data;
};

export const findUserByEmail = async (email: string) => {
  const find = await Axios.post(
    `${host}/contacts/search`,
    {
      query: {
        operator: "OR",
        value: [
          {
            field: "email",
            operator: "=",
            value: email,
          },
          // {
          //   field: "custom_attributes.user_email",
          //   operator: "=",
          //   value: email,
          // },
        ],
      },
    },
    {
      ...headers(),
    },
  );

  return find.data;
};

export const findUserByUserEmail = async (email: string) => {
  const find = await Axios.post(
    `${host}/contacts/search`,
    {
      query: {
        field: "user_email",
        operator: "=",
        value: email,
      },
    },
    {
      ...headers(),
    },
  );
  if (find.data.length > 1) {
    throw new Error(`Found more than one user with email ${email}`);
  }

  return find.data;
};

export const findUserByExternalId = async (id: string) => {
  const find = await Axios.post(
    `${host}/contacts/search`,
    {
      query: {
        field: "external_id",
        operator: "=",
        value: id,
      },
    },
    {
      ...headers(),
    },
  );

  if (find.data.length > 1) {
    throw new Error(`Found more than one user with external_id ${id}`);
  }

  return find.data;
};

export const archiveUser = async (userId: string) => {
  const post = await Axios.post(
    `${host}/contacts/${userId}/archive`,
    undefined,
    {
      ...headers(),
    },
  );

  return post.data;
};

export const unarchiveUser = async (userId: string) => {
  const post = await Axios.post(
    `${host}/contacts/${userId}/unarchive`,
    undefined,
    {
      ...headers(),
    },
  );

  return post.data;
};

export const createUser = async (params: any) => {
  const post = await Axios.post(`${host}/contacts`, params, {
    ...headers(),
  });

  return post.data;
};

export const updateContact = async (userId: string, params: any) => {
  const post = await Axios.put(`${host}/contacts/${userId}`, params, {
    ...headers(),
  });

  return post.data;
};

export const getContact = async (userId: string) => {
  const post = await Axios.get(`${host}/contacts/${userId}`, {
    ...headers(),
  });

  return post.data;
};

export const attachCompanyToUser = async (
  companyId: string,
  userId: string,
) => {
  const post = await Axios.post(
    `${host}/contacts/${userId}/companies`,
    {
      id: companyId,
    },
    {
      ...headers(),
    },
  );

  return post.data;
};

export const addTagToUser = async (intercomUserId: string, tagId: string) => {
  const attach = await Axios.post<
    any,
    {
      data: {
        id: string;
      };
    }
  >(`${host}/contacts/${intercomUserId}/tags`, { id: tagId }, { ...headers() });

  return attach;
};

export const formatIntercomTime = (isoStringTime: string | Date) => {
  return Math.round(new Date(isoStringTime).getTime() / 1000);
};

export const listTags = async () => {
  const tag = await Axios.get<
    any,
    {
      data: {
        type: string;
        data: {
          type: string;
          name: string;
          id: string;
        }[];
      };
    }
  >(`${host}/tags`, { ...headers() });

  return tag.data;
};
